export default function() {
  return {
    hubs: [],
    hubUUIDs: [],
    relayTokens: [],
    connectionStatuses: {}
  };
}
